import script from "./SearchOnMap.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchOnMap.vue?vue&type=script&setup=true&lang=js"

import "./SearchOnMap.vue?vue&type=style&index=0&id=5a743fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a743fc2"]])

export default __exports__